import React from "react";
import SeoHead from "../../../../components/SeoHead";
import EventOrganizersHero from "../event-organizers/EventOrganizersHero";
import SmartPlatform from "../event-organizers/SmartPlatform";
import PaymentStruggles from "../event-organizers/PaymentStruggles";
import WhyOrganizersLove from "../event-organizers/WhyOrganizersLove";
import HowNdovuWorks from "../event-organizers/HowNdovuWorks";
import { enterprisesConfig as config } from "../serviceConfig";

function Enterprises() {
  return (
    <div id="enterprises">
      <SeoHead title="Enterprises" description="Full financial control at scale. Integrate NdovuPay with your ERP and track payments across departments in real time." path="/services/enterprises" />
      <EventOrganizersHero hero={config.hero} />
      <SmartPlatform platform={config.platform} />
      <PaymentStruggles struggles={config.struggles} />
      <HowNdovuWorks how={config.how} />
      <WhyOrganizersLove why={config.why} />
    </div>
  );
}

export default Enterprises;
